(function(){
  var root=document.querySelector('[data-shgal]'); if(!root) return;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* invito a scorrere: clic = scende, sparisce dopo il primo scroll */
  var sc=root.querySelector('[data-shgal-scroll]');
  if(sc){
    sc.addEventListener('click',function(){ var h=root.querySelector('.shgal-hero'); window.scrollTo({top:h.getBoundingClientRect().bottom+window.pageYOffset-40,behavior:reduce?'auto':'smooth'}); });
    var hide=function(){ if(window.pageYOffset>80){ sc.classList.add('is-gone'); window.removeEventListener('scroll',hide); } };
    window.addEventListener('scroll',hide,{passive:true});
  }
  /* parole */
  root.querySelectorAll('[data-shgal-words]').forEach(function(el){
    var k=0;
    (function walk(node){
      [].slice.call(node.childNodes).forEach(function(c){
        if(c.nodeType===3){
          var frag=document.createDocumentFragment();
          c.textContent.split(/(\s+)/).forEach(function(part){
            if(!part) return;
            if(/^\s+$/.test(part)){ frag.appendChild(document.createTextNode(part)); return; }
            var w=document.createElement('span'); w.className='w'; var i=document.createElement('i'); i.style.setProperty('--i',k++); i.textContent=part; w.appendChild(i); frag.appendChild(w);
          });
          c.parentNode.replaceChild(frag,c);
        } else if(c.nodeType===1){ walk(c); }
      });
    })(el);
    el.classList.add('is-split');
  });
  /* video: parte solo quando e' visibile */
  var vids=[].slice.call(root.querySelectorAll('.shgal-vid__media video'));
  var items=root.querySelectorAll('[data-shgal-words],.shgal-fade,.shgal-fig');
  if(reduce||!('IntersectionObserver' in window)){
    items.forEach(function(e){e.classList.add('is-in');});
  } else {
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } }); },{rootMargin:'0px 0px -12% 0px',threshold:.12});
    items.forEach(function(e){ io.observe(e); });
  }
  if(vids.length && 'IntersectionObserver' in window){
    var vo=new IntersectionObserver(function(es){ es.forEach(function(e){ var v=e.target; if(e.isIntersecting&&!reduce){ v.muted=true; var p=v.play(); if(p&&p.catch) p.catch(function(){}); } else { v.pause(); } }); },{threshold:.35});
    vids.forEach(function(v){ v.muted=true; v.setAttribute('playsinline',''); vo.observe(v); });
  }
  /* binari orizzontali: su desktop scorrono con lo scroll verticale */
  var rails=[].slice.call(root.querySelectorAll('[data-shgal-rail]')).map(function(r){ return {el:r,track:r.querySelector('[data-shgal-rail-track]'),view:r.querySelector('[data-shgal-rail-view]'),bar:r.querySelector('[data-shgal-rail-bar]'),dist:0}; });
  var wide=window.matchMedia('(min-width: 990px) and (pointer: fine)');
  function layoutRails(){
    rails.forEach(function(r){
      if(wide.matches&&!reduce){
        r.el.classList.add('is-pinned');
        r.dist=Math.max(0,r.track.scrollWidth-window.innerWidth+Math.max(20,window.innerWidth*.04));
        r.el.style.height=(window.innerHeight+r.dist/1.6)+'px';
      } else {
        r.el.classList.remove('is-pinned'); r.el.style.height=''; r.track.style.transform=''; r.dist=0;
      }
    });
  }
  /* le foto del binario si caricano prima che entrino in vista */
  rails.forEach(function(r){
    var imgs=[].slice.call(r.el.querySelectorAll('img'));
    var eager=function(){ imgs.forEach(function(im){ im.loading='eager'; }); };
    if('IntersectionObserver' in window){ var ro=new IntersectionObserver(function(es){ if(es[0].isIntersecting){ eager(); ro.disconnect(); } },{rootMargin:'0px 0px 1500px 0px'}); ro.observe(r.el); } else eager();
  });
  rails.forEach(function(r){
    r.view.addEventListener('scroll',function(){ if(r.el.classList.contains('is-pinned')) return; var m=r.view.scrollWidth-r.view.clientWidth; r.bar.style.transform='scaleX('+(m>0?r.view.scrollLeft/m:0).toFixed(3)+')'; },{passive:true});
  });
  /* parallasse leggera delle foto, scorrimento fascia e binari */
  var figs=[].slice.call(root.querySelectorAll('[data-shgal-par]')), bands=[].slice.call(root.querySelectorAll('[data-shgal-band]')), ticking=false;
  function frame(){
    ticking=false; var vh=window.innerHeight;
    if(!reduce){
      figs.forEach(function(f){ var r=f.getBoundingClientRect(); if(r.bottom<-200||r.top>vh+200) return; var p=(r.top+r.height/2-vh/2)/vh; f.style.transform='translate3d(0,'+(p*parseFloat(f.getAttribute('data-shgal-par'))*-160).toFixed(1)+'px,0)'; });
      bands.forEach(function(b){ var r=b.getBoundingClientRect(); if(r.bottom<0||r.top>vh) return; var p=(r.top-vh)/vh; b.style.transform='translate3d('+(p*220).toFixed(1)+'px,0,0)'; });
    }
    rails.forEach(function(r){
      if(!r.el.classList.contains('is-pinned')) return;
      var rect=r.el.getBoundingClientRect(); var span=rect.height-vh; if(span<=0) return;
      var p=Math.min(1,Math.max(0,-rect.top/span));
      r.track.style.transform='translate3d('+(-p*r.dist).toFixed(1)+'px,0,0)';
      r.bar.style.transform='scaleX('+p.toFixed(3)+')';
    });
  }
  function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(frame); } }
  function onResize(){ layoutRails(); onScroll(); }
  window.addEventListener('scroll',onScroll,{passive:true}); window.addEventListener('resize',onResize);
  if(wide.addEventListener) wide.addEventListener('change',onResize);
  window.addEventListener('load',onResize);
  layoutRails(); frame();
})();
